import { makeStyles } from '@material-ui/core/styles';
import { modalPaperStyle } from '../../../../shared/components/RedesignModal/RedesignModal.styles';
import { primaryButtonStyle, secondaryButtonStyle } from '../../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useResumeTestModalStyles = makeStyles(() => ({
  modal: {
    ...modalPaperStyle,
    maxWidth: 464,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: spacing.sm,
      borderRadius: radius.sm,
    },
  },
  headerBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  headerTop: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  title: {
    margin: 0,
    flex: 1,
    minWidth: 0,
    color: colors.primaryDark,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.xl,
    lineHeight: 1.25,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      fontSize: fontSize.lg,
    },
  },
  close: {
    flexShrink: 0,
    margin: '-4px -4px 0 0',
    padding: 4,
    color: colors.primary,
    '&:hover': {
      backgroundColor: colors.progressTrack,
    },
  },
  description: {
    margin: 0,
    color: colors.textBody,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    lineHeight: 1.5,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    padding: spacing.sm,
    borderRadius: radius.sm,
    backgroundColor: colors.surface,
    boxSizing: 'border-box',
  },
  cardLabel: {
    margin: 0,
    color: colors.brownLight,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    letterSpacing: 0.24,
    textTransform: 'uppercase',
  },
  cardTitle: {
    margin: 0,
    color: colors.primaryDark,
    fontFamily: fonts.gothicBold,
    fontSize: fontSize.base,
    lineHeight: 1.4,
    letterSpacing: 0.32,
  },
  progressRow: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.sm,
  },
  progressTrack: {
    flex: 1,
    minWidth: 0,
    height: 8,
    borderRadius: radius.sm,
    backgroundColor: colors.progressTrack,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: radius.sm,
    backgroundColor: colors.primary,
    transition: 'width 180ms ease',
  },
  progressText: {
    margin: 0,
    color: colors.primary,
    fontFamily: fonts.gothic,
    fontSize: fontSize.sm,
    letterSpacing: 0.24,
    whiteSpace: 'nowrap',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  resumeButton: {
    ...primaryButtonStyle,
    textTransform: 'none',
  },
  restartButton: {
    ...secondaryButtonStyle,
    textTransform: 'none',
  },
}));
